import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Footer_ScreenContext } from "../footer/footer-context";

declare let window: any;

export interface IEndOfSProductFourthWeb_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IEndOfSProductFourthWeb_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  B2BAddBasketNew: any[];
  B2BAddBasketNew_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  Qty1BasketZero: number;
  Qty1BasketZero_dummy: number;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  GoBack: any;
  GoBack_dummy: any;
  B2BGetUserId: any[];
  B2BGetUserId_dummy: any[];
  B2BEndOfProductFourthPage: any[];
  B2BEndOfProductFourthPage_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  B2BNumberInputDegeriAtaMinusSize: any[];
  B2BNumberInputDegeriAtaMinusSize_dummy: any[];
  B2BAddBasketSimple: any[];
  B2BAddBasketSimple_dummy: any[];
  B2BNumberInputDegeriAtaPlusSize: any[];
  B2BNumberInputDegeriAtaPlusSize_dummy: any[];
  B2BNumberInputDegeriAta: any[];
  B2BNumberInputDegeriAta_dummy: any[];
}

export class EndOfSProductFourthWeb_ScreenBase extends React.PureComponent<
  IEndOfSProductFourthWeb_ScreenProps,
  any
> {
  static contextType = Footer_ScreenContext;
  declare context: React.ContextType<typeof Footer_ScreenContext>;
  endofsproductfourthweb_42738_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "782add75-a2c8-e698-bccf-af29bb1e9b35",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [
        {
          Id: 685851,
          PropertyName: "label",
          Value: "Sepete Ekle",
          TagName: "Button2_label",
        },
        {
          Id: 985049,
          PropertyName: "value",
          Value: "Koleksiyon Adı:",
          TagName: "Label13_value",
        },
        {
          Id: 490541,
          PropertyName: "value",
          Value: "Desen Adı:",
          TagName: "Label21_value",
        },
        {
          Id: 627959,
          PropertyName: "value",
          Value: "Renk",
          TagName: "Label19_value",
        },
        {
          Id: 665708,
          PropertyName: "label",
          Value: "Sepete Ekle",
          TagName: "Button3_label",
        },
        {
          Id: 442593,
          PropertyName: "value",
          Value: "Ebat",
          TagName: "Label1_value",
        },
        {
          Id: 963714,
          PropertyName: "value",
          Value: "Stok",
          TagName: "Label10_value",
        },
      ],
    },
    {
      Id: "c2176777-61f9-4e18-a818-fb50309cde20",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 685851,
          PropertyName: "label",
          Value: "Add to Basket",
          TagName: "Button2_label",
        },
        {
          Id: 985049,
          PropertyName: "value",
          Value: "Collection Name:",
          TagName: "Label13_value",
        },
        {
          Id: 490541,
          PropertyName: "value",
          Value: "Pattern Name:",
          TagName: "Label21_value",
        },
        {
          Id: 627959,
          PropertyName: "value",
          Value: "Colour",
          TagName: "Label19_value",
        },
        {
          Id: 665708,
          PropertyName: "label",
          Value: "Add to Basket",
          TagName: "Button3_label",
        },
        {
          Id: 442593,
          PropertyName: "value",
          Value: "Size",
          TagName: "Label1_value",
        },
        {
          Id: 963714,
          PropertyName: "value",
          Value: "Stock",
          TagName: "Label10_value",
        },
      ],
    },
    {
      Id: "4ab4d761-e5b3-402f-8b60-5f861309f448",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 685851, PropertyName: "label", Value: "Sepete Ekle" },
        { Id: 985049, PropertyName: "value", Value: "Koleksiyon Adı:" },
        { Id: 490541, PropertyName: "value", Value: "Desen Adı:" },
        { Id: 627959, PropertyName: "value", Value: "Renk" },
        { Id: 795914, PropertyName: "title", Value: "Title" },
        { Id: 442593, PropertyName: "value", Value: "Ebat" },
        {
          Id: 184125,
          PropertyName: "value",
          Value: "[datafield:sizedescription]",
        },
        { Id: 963714, PropertyName: "value", Value: "Stok" },
        {
          Id: 672479,
          PropertyName: "value",
          Value: "[datafield:inventoryqty1]",
        },
        { Id: 665708, PropertyName: "label", Value: "Sepete Ekle" },
        { Id: 114372, PropertyName: "value", Value: "[datafield:qty1basket]" },
        { Id: 974480, PropertyName: "placeholder", Value: "15" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.endofsproductfourthweb_42738_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      B2BAddBasketNew: [],
      Notify: false,
      Qty1BasketZero: 0,
      TriggerEvent: "",
      GoBack: "",
      B2BGetUserId: [],
      B2BEndOfProductFourthPage: [],
      NAVIGATE: "",
      B2BNumberInputDegeriAtaMinusSize: [],
      B2BAddBasketSimple: [],
      B2BNumberInputDegeriAtaPlusSize: [],
      B2BNumberInputDegeriAta: [],
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "endofsproductfourthweb",
        "footer_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.EndOfSProductFourthWebPageInit();
    } else if (
      !this.context?.callCallbackFunction ||
      this.context?.isMasterPageInitLoaded
    ) {
      this._prevMasterPageInitLoaded =
        this.context?.isMasterPageInitLoaded ?? false;
      await this.EndOfSProductFourthWebPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "endofsproductfourthweb",
      "footer_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["B2BCustomer"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "endofsproductfourthweb",
      "footer_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.EndOfSProductFourthWebPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.EndOfSProductFourthWebPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      endofsproductfourthweb_220832_value:
        this.state.B2BEndOfProductFourthPage?.at?.(0)?.imageOuterApply ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  EndOfSProductFourthWebPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      KUserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      CustomerUserID_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute02_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProductAttribute02 ??
          this.props.screenInputs.productattribute02,
        "string"
      ),
      ProductAttribute03_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProductAttribute03 ??
          this.props.screenInputs.productattribute03,
        "string"
      ),
      ColorCode_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ColorCode ?? this.props.screenInputs.colorcode,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BGetUserId = result?.data.b2BGetUserId;
    stateVars.B2BEndOfProductFourthPage =
      result?.data.b2BEndOfProductFourthPage;

    formVars.endofsproductfourthweb_166370_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BEndOfProductFourthPage !== undefined
          ? stateVars.B2BEndOfProductFourthPage?.length > 0
            ? stateVars.B2BEndOfProductFourthPage[0]
                .productAttribute02Description
            : null
          : this.state.B2BEndOfProductFourthPage?.length > 0
          ? this.state.B2BEndOfProductFourthPage[0]
              .productAttribute02Description
          : null
      );
    formVars.endofsproductfourthweb_87059_value = ReactSystemFunctions.toString(
      this,
      stateVars.B2BEndOfProductFourthPage !== undefined
        ? stateVars.B2BEndOfProductFourthPage?.length > 0
          ? stateVars.B2BEndOfProductFourthPage[0].productAttribute03Description
          : null
        : this.state.B2BEndOfProductFourthPage?.length > 0
        ? this.state.B2BEndOfProductFourthPage[0].productAttribute03Description
        : null
    );
    formVars.endofsproductfourthweb_220832_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BEndOfProductFourthPage !== undefined
          ? stateVars.B2BEndOfProductFourthPage?.length > 0
            ? stateVars.B2BEndOfProductFourthPage[0].imageOuterApply
            : null
          : this.state.B2BEndOfProductFourthPage?.length > 0
          ? this.state.B2BEndOfProductFourthPage[0].imageOuterApply
          : null
      );
    formVars.endofsproductfourthweb_879673_value =
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BEndOfProductFourthPage !== undefined
          ? stateVars.B2BEndOfProductFourthPage?.length > 0
            ? stateVars.B2BEndOfProductFourthPage[0].colorDescription
            : null
          : this.state.B2BEndOfProductFourthPage?.length > 0
          ? this.state.B2BEndOfProductFourthPage[0].colorDescription
          : null
      );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.EndOfSProductFourthWebPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    this.context.setMasterPageInitLoaded(false);
    this.context.setMasterPageRecurringLoaded(false);
    this.context.setShouldTriggerPageInit(true);
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  EndOfSProductFourthWebComponent_685851_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerUserID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ProductAttribute03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BEndOfProductFourthPage !== undefined
            ? stateVars.B2BEndOfProductFourthPage?.length > 0
              ? stateVars.B2BEndOfProductFourthPage[0].productAttribute03
              : null
            : this.state.B2BEndOfProductFourthPage?.length > 0
            ? this.state.B2BEndOfProductFourthPage[0].productAttribute03
            : null
        ),
        "string"
      ),
      KUserID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      LineDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebComponent_685851_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BAddBasketNew = result?.data.b2BAddBasketNew;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_685851_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_685851_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BAddBasketNew !== undefined
          ? stateVars.B2BAddBasketNew?.length > 0
            ? stateVars.B2BAddBasketNew[0].message
            : null
          : this.state.B2BAddBasketNew?.length > 0
          ? this.state.B2BAddBasketNew[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_685851_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_685851_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProductAttribute03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BEndOfProductFourthPage !== undefined
            ? stateVars.B2BEndOfProductFourthPage?.length > 0
              ? stateVars.B2BEndOfProductFourthPage[0].productAttribute03
              : null
            : this.state.B2BEndOfProductFourthPage?.length > 0
            ? this.state.B2BEndOfProductFourthPage[0].productAttribute03
            : null
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebComponent_685851_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Qty1BasketZero = result?.data.qty1BasketZero;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_685851_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_685851_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.EndOfSProductFourthWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfSProductFourthWebComponent_576795_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProductAttribute03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BEndOfProductFourthPage !== undefined
            ? stateVars.B2BEndOfProductFourthPage?.length > 0
              ? stateVars.B2BEndOfProductFourthPage[0].productAttribute03
              : null
            : this.state.B2BEndOfProductFourthPage?.length > 0
            ? this.state.B2BEndOfProductFourthPage[0].productAttribute03
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebComponent_576795_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Qty1BasketZero = result?.data.qty1BasketZero;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_576795_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_576795_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfSProductFourthWebComponent_166370_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProductAttribute03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BEndOfProductFourthPage !== undefined
            ? stateVars.B2BEndOfProductFourthPage?.length > 0
              ? stateVars.B2BEndOfProductFourthPage[0].productAttribute03
              : null
            : this.state.B2BEndOfProductFourthPage?.length > 0
            ? this.state.B2BEndOfProductFourthPage[0].productAttribute03
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebComponent_166370_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Qty1BasketZero = result?.data.qty1BasketZero;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_166370_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_166370_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/endofproductcollectionweb") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "EndOfSProductFourthWeb",
      "EndOfProductCollectionWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfSProductFourthWebComponent_87059_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ProductAttribute03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.B2BEndOfProductFourthPage !== undefined
            ? stateVars.B2BEndOfProductFourthPage?.length > 0
              ? stateVars.B2BEndOfProductFourthPage[0].productAttribute03
              : null
            : this.state.B2BEndOfProductFourthPage?.length > 0
            ? this.state.B2BEndOfProductFourthPage[0].productAttribute03
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebComponent_87059_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Qty1BasketZero = result?.data.qty1BasketZero;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_87059_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_87059_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/endofproductdesignweb") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "EndOfProductDesignWeb",
      "ProductAttribute02",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.ProductAttribute02 ??
          this.props.screenInputs.productattribute02,
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "EndOfSProductFourthWeb",
      "EndOfProductDesignWeb",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfSProductFourthWebComponent_261592_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "endofsproductfourthweb_42738_value",
          "id"
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebComponent_261592_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BNumberInputDegeriAtaMinusSize =
      result?.data.b2BNumberInputDegeriAtaMinusSize;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_261592_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_261592_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.EndOfSProductFourthWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfSProductFourthWebComponent_665708_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Qty_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "endofsproductfourthweb_42738_value",
          "qty1Basket"
        ),
        "number"
      ),
      CustomerUserID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.B2BGetUserId !== undefined
            ? stateVars.B2BGetUserId?.length > 0
              ? stateVars.B2BGetUserId[0].id
              : null
            : this.state.B2BGetUserId?.length > 0
            ? this.state.B2BGetUserId[0].id
            : null
        ),
        "Guid"
      ),
      ItemId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "endofsproductfourthweb_42738_value",
          "id"
        ),
        "Guid"
      ),
      KUserID_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      LineDescription_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebComponent_665708_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BAddBasketSimple = result?.data.b2BAddBasketSimple;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_665708_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_665708_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BAddBasketSimple !== undefined
          ? stateVars.B2BAddBasketSimple?.length > 0
            ? stateVars.B2BAddBasketSimple[0].message
            : null
          : this.state.B2BAddBasketSimple?.length > 0
          ? this.state.B2BAddBasketSimple[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    await this.EndOfSProductFourthWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfSProductFourthWebComponent_827422_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      ItemId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "endofsproductfourthweb_42738_value",
          "id"
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebComponent_827422_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BNumberInputDegeriAtaPlusSize =
      result?.data.b2BNumberInputDegeriAtaPlusSize;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_827422_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_827422_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.EndOfSProductFourthWebPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  EndOfSProductFourthWebComponent_974480_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      QtyInputValue_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "Table_42738_qty1Basket",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ItemId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "endofsproductfourthweb_42738_value",
          "id"
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "EndOfSProductFourthWeb/EndOfSProductFourthWebComponent_974480_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.B2BNumberInputDegeriAta = result?.data.b2BNumberInputDegeriAta;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.EndOfSProductFourthWebComponent_974480_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  EndOfSProductFourthWebComponent_974480_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.EndOfSProductFourthWebPageInit();

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.B2BNumberInputDegeriAta !== undefined
          ? stateVars.B2BNumberInputDegeriAta?.length > 0
            ? stateVars.B2BNumberInputDegeriAta[0].message
            : null
          : this.state.B2BNumberInputDegeriAta?.length > 0
          ? this.state.B2BNumberInputDegeriAta[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.EndOfSProductFourthWebPageInit();
    }
  }
}
